<button matButton [routerLink]="buttonLink" (click)="action.emit()">
  <mat-icon>arrow_left</mat-icon>
  <ng-content></ng-content>
</button>
